
import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchUserList, fetchAccessLevels, fetchUserRoles,saveNewUserDetails,fetchAssetVisibility, editUserData,deleteUserData } from "../thunk/UsersThunk";

const initialData: any = [];

const UserListSlice: Slice<any, {}, "UserListSlice"> = createSlice({
  name: "UserListSlice",
  initialState: {
    data: initialData,
    isLoading: false,
    error: "",
    accessLevels: [],
    roles: [],
    accessLevelsLoading: false,
    rolesLoading: false,
    accessLevelsError: "",
    rolesError: "",
  },
  reducers: {},
  extraReducers(builder) {
    // Handle fetchUserList
    builder.addCase(fetchUserList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchUserList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchUserList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message ?? "";
    });

    // Handle fetchAccessLevels
    builder.addCase(fetchAccessLevels.pending, (state) => {
      state.accessLevelsLoading = true;
    });
    builder.addCase(fetchAccessLevels.fulfilled, (state, action) => {
      state.accessLevelsLoading = false;
      state.accessLevels = action.payload;
    });
    builder.addCase(fetchAccessLevels.rejected, (state, action) => {
      state.accessLevelsLoading = false;
      state.accessLevelsError = action.error.message ?? "";
    });

    // Handle fetchUserRoles
    builder.addCase(fetchUserRoles.pending, (state) => {
      state.rolesLoading = true;
    });
    builder.addCase(fetchUserRoles.fulfilled, (state, action) => {
      state.rolesLoading = false;
      state.roles = action.payload;
    });
    builder.addCase(fetchUserRoles.rejected, (state, action) => {
      state.rolesLoading = false;
      state.rolesError = action.error.message ?? "";
    });

     // Handle saveNewUserDetails
     builder.addCase(saveNewUserDetails.pending, (state) => {
        state.rolesLoading = true;
      });
      builder.addCase(saveNewUserDetails.fulfilled, (state, action) => {
        state.rolesLoading = false;
        state.roles = action.payload;
      });
      builder.addCase(saveNewUserDetails.rejected, (state, action) => {
        state.rolesLoading = false;
        state.rolesError = action.error.message ?? "";
      });

      //Handle editUserData
      builder.addCase(editUserData.pending, (state) => {
        state.rolesLoading = true;
      });
      builder.addCase(editUserData.fulfilled, (state, action) => {
        state.rolesLoading = false;
        state.roles = action.payload;
      });
      builder.addCase(editUserData.rejected, (state, action) => {
        state.rolesLoading = false;
        state.rolesError = action.error.message ?? "";
      });

      //Handle fetchAssetVisibility
      builder.addCase(fetchAssetVisibility.pending, (state) => {
        state.rolesLoading = true;
      });
      builder.addCase(fetchAssetVisibility.fulfilled, (state, action) => {
        state.rolesLoading = false;
        state.roles = action.payload;
      });
      builder.addCase(fetchAssetVisibility.rejected, (state, action) => {
        state.rolesLoading = false;
        state.rolesError = action.error.message ?? "";
      });

      //Handle deleteUserData
      builder.addCase(deleteUserData.pending, (state) => {
        state.rolesLoading = true;
      });
      builder.addCase(deleteUserData.fulfilled, (state, action) => {
        state.rolesLoading = false;
        state.roles = action.payload;
      });
      builder.addCase(deleteUserData.rejected, (state, action) => {
        state.rolesLoading = false;
        state.rolesError = action.error.message ?? "";
      });
  },
});

export default UserListSlice;